import React from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import Typography from '@mui/material/Typography';
/** import mui components in the section above, Sort Lines Ascending */

import Separator from 'widgets-v5/separator';
import Spacer from 'widgets-v5/spacer';
/** import widgets components in the section above, Sort Lines Ascending */

import {
    CREATIVE_HISTORY_CELL_STYLE,
    CREATIVE_HISTORY_ID_COLUMN_STYLE,
    CREATIVE_HISTORY_NAME_CELL_STYLE,
    CREATIVE_HISTORY_TABLE_STYLE,
    WEATHER_HISTORY_CONDITION_COLUMN_STYLE,
    WEATHER_HISTORY_QUALIFIER_COLUMN_STYLE,
    WEATHER_HISTORY_TIMEFRAME_COLUMN_STYLE,
    WEATHER_HISTORY_VALUE_COLUMN_STYLE,
} from './creative-history-styles';
/** import multiple application imports in the section above, Sort Lines Ascending */

import { WeatherConditionFieldsTableCells } from './weather-condition-history-fields';
/** import single application imports in the section above, Sort Lines Ascending */

/**
 * Weather rotation rule block for ad history (table layout matching Creatives weather rotation).
 *
 * @param {Object} props
 * @param {Object} props.setting - Weather rotation rule from snapshot
 * @param {string} [props.title] - Rule heading (e.g. "Rule 1", "Default Rule")
 * @param {Object} props.weatherConditionsData - Bound selector fns from Redux
 * @param {number|string} props.creativeId - Creative markup id
 * @param {string} props.creativeName - Creative display name
 */
export const WeatherRotationRuleSummary = ({
    setting,
    title,
    weatherConditionsData,
    creativeId,
    creativeName,
}) => {
    const isDefault = setting.isDefault;
    const cellStyle = CREATIVE_HISTORY_CELL_STYLE;

    return (
        <React.Fragment>
            {title && (
                <Separator
                    label={
                        <Typography variant="subtitle1" gutterBottom>
                            {title}
                        </Typography>
                    }
                />
            )}
            <table style={CREATIVE_HISTORY_TABLE_STYLE}>
                <colgroup>
                    <col style={CREATIVE_HISTORY_ID_COLUMN_STYLE} />
                    <col />
                    {!isDefault && (
                        <React.Fragment>
                            <col style={WEATHER_HISTORY_CONDITION_COLUMN_STYLE} />
                            <col style={WEATHER_HISTORY_QUALIFIER_COLUMN_STYLE} />
                            <col style={WEATHER_HISTORY_VALUE_COLUMN_STYLE} />
                            <col style={WEATHER_HISTORY_TIMEFRAME_COLUMN_STYLE} />
                        </React.Fragment>
                    )}
                </colgroup>
                <tbody>
                    <tr>
                        <td style={cellStyle}>
                            <Typography variant="subtitle2">ID</Typography>
                            <Typography variant="body2" component="div">
                                <div>{creativeId}</div>
                            </Typography>
                        </td>
                        <td style={CREATIVE_HISTORY_NAME_CELL_STYLE}>
                            <Typography variant="subtitle2">Name</Typography>
                            <Typography variant="body2" component="div">
                                <div>{creativeName}</div>
                            </Typography>
                        </td>
                        {!isDefault && (
                            <WeatherConditionFieldsTableCells
                                condition={setting}
                                weatherConditionsData={weatherConditionsData}
                                cellStyle={CREATIVE_HISTORY_NAME_CELL_STYLE}
                                leafValues
                            />
                        )}
                    </tr>
                </tbody>
            </table>
            <Spacer />
        </React.Fragment>
    );
};
